export const canRenewMembership = membership => !!membership && membership.member_type === 'user'
